var StaticPage = /** @class */ (function () {
    function StaticPage(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.slug = obj.slug;
        this.position = obj.position;
        this.bg_description = obj.bg_description;
        this.bg_description_json = obj.bg_description_json;
        this.en_description = obj.en_description;
        this.en_description_json = obj.en_description_json;
        this.bg_bottom_description = obj.bg_bottom_description;
        this.bg_bottom_description_json = obj.bg_bottom_description_json;
        this.en_bottom_description = obj.en_bottom_description;
        this.en_bottom_description_json = obj.en_bottom_description_json;
        this.category_id = obj.category_id ? obj.category_id : obj.category ? obj.category.id : null;
        this.brand_category_id = obj.brand_category_id ? obj.brand_category_id : obj.brand_category_id ? obj.brand_category_id : null;
        this.display = obj.display;
        this.canonical_url = obj.canonical_url;
        this.meta_title = obj.meta_title;
        this.meta_description = obj.meta_description;
    }
    Object.defineProperty(StaticPage.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "Slug", {
        get: function () {
            return this.slug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "BgDescription", {
        get: function () {
            return this.bg_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "BgDescriptionJson", {
        get: function () {
            return this.bg_description_json;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "EnDescription", {
        get: function () {
            return this.en_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "EnDescriptionJson", {
        get: function () {
            return this.en_description_json;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "BgBottomDescription", {
        get: function () {
            return this.bg_bottom_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "BgBottomDescriptionJson", {
        get: function () {
            return this.bg_bottom_description_json;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "EnBottomDescription", {
        get: function () {
            return this.en_bottom_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "EnBottomDescriptionJson", {
        get: function () {
            return this.en_bottom_description_json;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "Display", {
        get: function () {
            return this.display;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "CanonicalUrl", {
        get: function () {
            return this.canonical_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "MetaTitle", {
        get: function () {
            return this.meta_title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StaticPage.prototype, "MetaDescription", {
        get: function () {
            return this.meta_description;
        },
        enumerable: false,
        configurable: true
    });
    return StaticPage;
}());
export { StaticPage };
export function createStaticPage(obj, id) {
    return new StaticPage(obj, id);
}
export function createStaticPages(rawStaticPages) {
    var staticPages = [];
    var rawStaticPagesData = rawStaticPages.data;
    for (var _i = 0, rawStaticPagesData_1 = rawStaticPagesData; _i < rawStaticPagesData_1.length; _i++) {
        var rawStaticPage = rawStaticPagesData_1[_i];
        var staticPage = createStaticPage(rawStaticPage.attributes, rawStaticPage.id);
        staticPages.push(staticPage);
    }
    return staticPages;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/brand/staticPage.ts
// module id = 144
// module chunks = 0